import {Component, OnDestroy, OnInit} from '@angular/core';
import {MenuTree} from './MenuTree';
import {MenuLevel} from './MenuLevel';
import {UiService} from '../../services/ui-service/ui.service';
import {RoutingService} from '../../services/routing-service/routing.service';
import {ApiService} from '../../services/api-service/api.service';
import { Router, Routes } from '@angular/router';
import {
  LevelLink
} from './LevelLink';
import {PageServicesComponent} from '../../pages/page-services/page-services.component';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})

export class SidebarComponent implements OnInit {
  
  private menuItems: MenuTree = new MenuTree();
  private currentLevel: MenuLevel = this.menuItems.getLevels()[0];
  public settings: any[];
  private services: any[];

  private servicesRoutes = [];
  private servicesLevel: MenuLevel[] = [];


  getCurrentLevel = (): MenuLevel => {
    return this.currentLevel;
  };

  setCurrentLevel = (level: MenuLevel): void => {
    this.currentLevel = level;
  };

  getMenuItems = (): MenuTree => {
    return this.menuItems;
  };


  handleClose = (event) => {
    this.closeSidebar();
    this.UIservice.shiftHeader(event);
  };


  handleRouteChange = (event) => {
    this.UIservice.closeSidebar(event);
    this.UIservice.shiftHeader(event);
    this.UIservice.closeRightMenu(event);
  };

  openSidebar = () => {
    let sidebar = document.getElementsByClassName('sidebar')[0];
    let rightMenuToggler = document.getElementsByClassName('rmenu-toggler')[0];
    let main = document.getElementsByClassName('animation-target')[0];

    if (screen.width < 576) {
      sidebar.classList.add('mobile-menu-open');
    } else {
      sidebar.classList.add('closed');
    }
    main.classList.add('--blured');
    if (rightMenuToggler != null) {
      rightMenuToggler.classList.toggle('cdk-visually-hidden');
    }
  };

  closeSidebar = () => {
    let sidebar = document.getElementsByClassName('sidebar')[0];
    let rightMenuToggler = document.getElementsByClassName('rmenu-toggler')[0];
    let main = document.getElementsByClassName('animation-target')[0];

    if (screen.width < 576) {
      sidebar.classList.remove('mobile-menu-open');
    } else {
      sidebar.classList.remove('closed');
    }
    main.classList.remove('--blured');
    if (rightMenuToggler != null) {
      rightMenuToggler.classList.remove('cdk-visually-hidden');
    }
  };

  toggleSidebar = () => {
    let sidebar = document.getElementsByClassName('sidebar')[0];
    let rightMenuToggler = document.getElementsByClassName('rmenu-toggler')[0];

    if (screen.width < 576) {
      sidebar.classList.toggle('mobile-menu-open');
    } else {
      sidebar.classList.toggle('closed');
    }
    if (rightMenuToggler != null) {
      rightMenuToggler.classList.toggle('cdk-visually-hidden');
    }
  };


  goForward = (childId: number, event): void => {
    event.preventDefault();
    for (let item of this.getMenuItems().getLevels()) {

      if (item.getLevelId() === childId) {
        this.setCurrentLevel(item);
      }
    }
  }

  goBack = (parentId: number, event): void => {
    event.preventDefault();
    for (let item of this.getMenuItems().getLevels()) {
      if (item.getLevelId() === parentId) {
        this.setCurrentLevel(item);
      }
    }
  }

  goHome = (event): void => {
    event.preventDefault();
    for (let item of this.getMenuItems().getLevels()) {
      if (item.getLevelId() === 0) {
        this.setCurrentLevel(item);
        this.UIservice.closeRightMenu(event);
        this.UIservice.setRightMenuActiveStepIndex(0);
      }
    }
    
  }

  constructor(public UIservice: UiService, private apiService: ApiService, private Router: Router) {
    this.settings = this.apiService.settings;
    fetch('https://api.lightstudio.ua/v1/products/services')
    .then((response) => {
      return response.json();
    })
    .then((data) => {
     this.services = data.data;
      this.menuItems.addLevel(
          new MenuLevel(
             this.services.map((el) => new LevelLink(el.title, 'services/' + el.sku, -1, 1)),
            0, 2),
      );
    });
  }


  ngOnInit() {
    this.UIservice.listenSidbarMenuToggle().subscribe(value => {
      this.toggleSidebar();
    });
    this.UIservice.listenSidebarClosing().subscribe(value => {
      this.closeSidebar();
    });
    this.UIservice.listenSidebarOpening().subscribe(value => {
      this.openSidebar();
    });

  }




}
